/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React from 'react';
import StatsBar from '../../../Common/StatsBar';
import { getStatsBarData, getSponsorData } from '../../../../utils/utils';
import { CONTENT_TYPE } from '../../../../constants/globalConstants';
import Sponsor from '../../../Common/Sponsor';
import Transform from '../../../../data-transform';
const PlayerProfile = ({ data, container, source, isCollection }) => {
  const sponsorInfo = data && getSponsorData(data.sponsordetailinfo_s);
  return (
    <React.Fragment>
      <Sponsor
        contentType={data.contenttype_t}
        varient={''}
        sponsorInfo={sponsorInfo}
        grid={'grid-12'}
        type={CONTENT_TYPE}
        author={data.authorname_s}
        cardName={`${data.firstname_t} ${data.lastname_t}`}
        container={container}
        createdDateTime={data.appearance_tdt}
        itemId={data.itemid_s}
        tags={data.taglist_sm}
      ></Sponsor>
      <Transform isCollection={isCollection} container={container} data={data} source={source} />
      <StatsBar item={getStatsBarData(data)} />
    </React.Fragment>
  );
};
export default PlayerProfile;
